export default "__VITE_ASSET__CEf1seVY__"